<template>
    <aside class="settings-sidebar">
        <h2 class="sidebar-title">{{ sidebarTitle }}</h2>
        <ul class="menu-list">
            <li class="menu-item" v-for="(menu, index) in menuList" :key="index">
                <a
                        :href="`#${menu.key}`"
                        class="menu-link"
                        :class="{ active: activeMenu === menu.key }"
                        @click.prevent="handleMenuClick(menu.key)"
                >
                    <span class="menu-icon">{{ menu.icon }}</span>
                    <span>{{ menu.title }}</span>
                </a>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'SidebarMenu',
    props: {
        menuList: {
            type: Array,
            required: true,
            default: () => []
        },
        activeMenu: {
            type: String,
            default: 'general'
        },
        sidebarTitle: {
            type: String,
            default: '系统设置'
        }
    },
    methods: {
        handleMenuClick(menuKey) {
            // 触发菜单点击事件，通知父组件
            this.$emit('menu-click', menuKey);
        }
    }
}
</script>

<style scoped>
/* 侧边栏菜单样式 - 与原样式保持一致 */
.settings-sidebar {
    width: 280px;
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1.5rem;
    height: fit-content;
    position: sticky;
    top: 100px;
}

.sidebar-title {
    font-size: 1.1rem;
    color: #00ff96;
    margin-bottom: 1.5rem;
}

.menu-list {
    list-style: none;
    margin-left: -20%;
}

.menu-item {
    margin-bottom: 0.5rem;
}

.menu-link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    color: #94a3b8;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.menu-link:hover {
    background: rgba(0, 255, 150, 0.1);
    color: #00ff96;
}

.menu-link.active {
    background: rgba(0, 255, 150, 0.2);
    color: #00ff96;
    border-left: 3px solid #00ff96;
}

.menu-icon {
    font-size: 1.2rem;
}
</style>